/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
// import CampaignIcon from '@material-ui/icons/Campaign';
import { ImHistory } from "react-icons/im";
import { GoRequestChanges } from "react-icons/go";
import { FaUserCog } from "react-icons/fa";
import { FaUserShield } from "react-icons/fa";
import { FaRegHandshake, FaRegUserCircle } from "react-icons/fa";
import { BiAddToQueue } from "react-icons/bi";
import { TiGroupOutline } from "react-icons/ti";
import { FaChartPie, FaRegEnvelope } from "react-icons/fa";
import { GoReport } from "react-icons/go";
import { IoIosNotifications } from "react-icons/io"
import { HiUserGroup } from "react-icons/hi";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/users", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/users">
            <span className="svg-icon menu-icon">
              {/* <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} /> */}
              <FaRegUserCircle />
            </span>
            <span className="menu-text">Users</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/assets", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/assets">
            <span className="svg-icon menu-icon">
              {/* <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/account.svg"
                )}
              /> */}
              {/* <RiShieldUserLine/> */}
              <FaUserShield />
            </span>
            <span className="menu-text">Assets</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/humanResource", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/humanResource">
            <span className="svg-icon menu-icon">
              {/* <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/user.svg"
                )}
              /> */}
              {/* <i class="fas fa-user-cog"></i> */}
              <FaUserCog />
            </span>
            <span className="menu-text">HR Account</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/employeelist", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/employeelist">
            <span className="svg-icon menu-icon">
              <TiGroupOutline />
            </span>
            <span className="menu-text">Employee </span>
          </NavLink>
        </li>
        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/partners", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/partners">
            <span className="svg-icon menu-icon">
              <FaRegHandshake />
            </span>
            <span className="menu-text">Partners</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}


        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/merchants", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/merchants">
            <span className="svg-icon menu-icon">
              <HiUserGroup />
            </span>
            <span className="menu-text">Merchants</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}




        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/campaigns", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/campaigns">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/Communication/campaign.svg"
                )}
              />
            </span>
            <span className="menu-text">Campaigns</span>
          </NavLink>
        </li>

        {/*begin::1 Level*/}

        <li
          className={`menu-item ${getMenuItemActive("/categorynames", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/categorynames">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/menu.svg")}
              />
            </span>
            <span className="menu-text">Category Name</span>
          </NavLink>
        </li>

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/requests", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/requests">
            <span className="svg-icon menu-icon">
              <GoRequestChanges />
            </span>
            <span className="menu-text">Requests by Employee</span>
          </NavLink>
        </li>

        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/by-merchant", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/by-merchant">
            <span className="svg-icon menu-icon">
              <GoRequestChanges />
            </span>
            <span className="menu-text">Requests by Merchant</span>
          </NavLink>
        </li>

        {/*end::1 Level*/}
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive(
            "/expectedcampaigns",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/expectedcampaigns">
            <span className="svg-icon menu-icon">
              <BiAddToQueue />
            </span>
            <span className="menu-text">Expected Campaigns</span>
          </NavLink>
        </li>


        <li
          className={`menu-item ${getMenuItemActive("/complaints", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/complaints">
            <span className="svg-icon menu-icon">
              <FaRegEnvelope />
            </span>
            <span className="menu-text">Complaints</span>
          </NavLink>
        </li>

        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/usagehistory", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/usagehistory">
            <span className="svg-icon menu-icon">
              <ImHistory />
            </span>
            <span className="menu-text">Usage History</span>
          </NavLink>
        </li>

        {/*end::1 Level*/}


        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/notifications", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/notifications">
            <span className="svg-icon menu-icon">
              <IoIosNotifications />
            </span>
            <span className="menu-text">Notifications</span>
          </NavLink>
        </li>

        {/*end::1 Level*/}


        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <FaChartPie />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>

        {/*end::1 Level*/}

        <li
          className={`menu-item ${getMenuItemActive("/reports", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/reports">
            <span className="svg-icon menu-icon">
              <GoReport />
            </span>
            <span className="menu-text">Reports</span>
          </NavLink>
        </li>


      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
